export default __webpack_public_path__ + "static/media/logo.00001256.svg";